<template>
    <div id="wrapper">
        <navbar></navbar>
        <div class="super-main-container">
            <sidebar/>
            <div class="main-container">
                <!-- <breadcrumb></breadcrumb> -->
                <app-main class="appmain-container"/>
            </div>
            <div class="empty"></div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Navbar from '@/components/layout/navbar'
import Sidebar from '@/components/layout/sidebar'
// import Breadcrumb from '@/components/layout/breadcrumb'
import AppMain from '@/components/layout/appMain'
import Footer from '@/components/layout/footer'
export default {
    name: 'layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        // Breadcrumb,
        Footer
    },
    data () {
        return {
            input: ''
        }
    }
}
</script>
